<template>
  <div class="multiple-sites-information">
    <div class="col-12">
      <div class="row">
        <div class="col-4 information-col-4 information--left">
          <div class="multiple-sites-total multiple-sites-total-space">
            <div class="col-12 total-sites-chart-column">
              <div class="alarm-summary-legend">
                <div class="sites-legend">
                  <span class="circle green-circle"></span>
                  <div class="sites-legend-desc">
                    <strong class="legend-desc-num">{{ dataForm && dataForm.count ? formatCommasAndDecimalForNumber(dataForm.count.normal) : '' }}</strong>
                    <p class="legend-desc-status">Normal <span class="status-percent">{{ dataForm?.status_percent ? formatDecimalNumber(dataForm.status_percent.normal) : '' }}%</span></p>
                  </div>
                </div>
                <div class="sites-legend">
                  <span class="circle yellow-circle"></span>
                  <div class="sites-legend-desc">
                    <strong class="legend-desc-num">{{ dataForm && dataForm.count ? formatCommasAndDecimalForNumber(dataForm.count.alarm) : '' }}</strong>
                    <p class="legend-desc-status">Alarm <span class="status-percent">{{ dataForm?.status_percent ? formatDecimalNumber(dataForm.status_percent.alarm) : '' }}%</span></p>
                  </div>
                </div>
                <div class="sites-legend">
                  <span class="circle grey-circle"></span>
                  <div class="sites-legend-desc">
                    <strong class="legend-desc-num">{{ dataForm && dataForm.count ? formatCommasAndDecimalForNumber(dataForm.count.offline) : '' }}</strong>
                    <p class="legend-desc-status">Offline <span class="status-percent">{{ dataForm?.status_percent ? formatDecimalNumber(dataForm.status_percent.offline) : '' }}%</span></p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="site-information-form">
            <div class="site-information-content">
              <div class="site-information-detail">
                <div class="detail-desc detail-desc-padding">
                  <div class="row-info-space">
                    <h2 class="site-heading">SITE INFORMATION</h2>
                    <div class="site-actions">
                      <v-btn 
                        :disabled="!siteInfo || notAllowedActions()" 
                        :class="`${!siteInfo ? 'buttons-disabled' : ''}`" 
                        @click="openDialogEdit(siteInfo)" class="site-action-btn" 
                        icon
                        title="Edit Site"
                      >
                        <img src="@/assets/tables/asset_edit_white.svg" />
                      </v-btn>
                      <v-btn 
                        :disabled="!siteInfo || notAllowedActions()" 
                        :class="`${!siteInfo ? 'buttons-disabled' : ''}`" 
                        @click="openConfirmDialog(siteInfo, deleteSite, 'Delete Site', 'You are about to de-register this site. This site will no longer be available')" class="site-action-btn" 
                        icon
                        title="Delete Site"
                      >
                        <img src="@/assets/tables/asset_delete_white.svg" />
                      </v-btn>
                    </div>
                  </div>
                  <p v-if="siteInfo" class="project-address">{{ siteInfo.global }} / {{ siteInfo.regional }} / {{ siteInfo.area }} / {{ siteInfo.project }}</p>
                </div>
                <div class="detail-desc">
                  <div class="row-info-space">
                    <p class="detail-desc-title">SITE ID</p>
                    <p class="detail-desc-content">{{ siteInfo ? siteInfo.id : '' }}</p>
                  </div>
                  <div class="row-info-space">
                    <p class="detail-desc-title">SITE NAME</p>
                    <p class="detail-desc-content">{{ siteInfo ? siteInfo.site_name : '' }}</p>
                  </div>
                  <div class="row-info-space">
                    <p class="detail-desc-title">LOCATION</p>
                    <p class="detail-desc-content">{{ siteInfo ? siteInfo.address : '' }}</p>
                  </div>
                </div>

                <div class="detail-desc">
                  <div class="row-info-space">
                    <p class="detail-desc-title">COMMISSIONED DATE</p>
                    <p class="detail-desc-content">{{ siteInfo?.commissioned_date ? MOMENT(siteInfo.commissioned_date, "DD/MM/YYYY") : '' }}</p>
                  </div>
                  <div class="row-info-space">
                    <p class="detail-desc-title">SITE STATUS</p>
                    <p class="detail-desc-content" :style="`color: ${STATUS_COLORS[siteInfo?.status]}`">{{ siteInfo ? capitalizeFirstLetter(siteInfo.status) : '' }}</p>
                  </div>
                </div>

                <div class="detail-desc">
                  <p>DEVICES</p>
                  <div class="info-box">
                    <div class="row-info-space info-box-content">
                      <p class="detail-desc-title">PV</p>
                      <p class="detail-desc-content">{{ siteInfo?.pv_capacity ? formatDecimalNumber(siteInfo.pv_capacity) + 'kW' : '' }}</p>
                    </div>
                    <div class="row-info-space info-box-content">
                      <p class="detail-desc-title">EVSE</p>
                      <p class="detail-desc-content">{{ siteInfo?.evse_capacity ? formatDecimalNumber(siteInfo.evse_capacity) + 'kW' : '' }}</p>
                    </div>
                    <div class="row-info-space info-box-content">
                      <p class="detail-desc-title">BESS</p>
                      <p class="detail-desc-content">{{ siteInfo?.bess_capacity ? formatDecimalNumber(siteInfo.bess_capacity) + 'kWh' : '' }}</p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="site-information-button">
                <router-link :to="{ path: `/single-site/${$store.state.siteId}` }" :style="`${siteInfo ? '' : 'pointer-events: none'}`">
                  <v-btn
                    title="Go To Site"
                    class="v-btn-site-information button-hover"
                    @click="saveSiteIdCurrent"
                    :disabled="!siteInfo"
                  >
                    <span class="v-btn-site-text">GO TO SITE</span>
                    <i class="fa-solid fa-chevron-right v-btn-site-icon"></i>
                  </v-btn>
                </router-link>
              </div>
            </div>
          </div>
        </div>
        <div class="col-8 information-col-8 information--right">
          <div class="switch-component switch-component-space">
            <button 
              :disabled="notAllowedActions()"
              :class="`${notAllowedActions() ? 'not-allow-button' : ''}`"
              class="dialog-default-button data-table-add-size dialog-bg-grey-button add-site-btn add-user-btn button-hover" 
              @click="openDialogAddProject"
            >
              Add New Project
            </button>
            <button
              :disabled="notAllowedActions()"
              :class="`${notAllowedActions() ? 'not-allow-button' : ''}`" 
              class="dialog-default-button data-table-add-size dialog-bg-grey-button add-site-btn add-user-btn button-hover" 
              @click="openDialogAddSite"
            >
              Add New Site
            </button>
            <v-text-field
              v-model="searchSite"
              placeholder="Search..."
              class="search-multi-site"
              prepend-inner-icon="fas fa-search"
              rounded
              outlined
              filled
              @input="handleSearchSite"
            ></v-text-field>
            <v-btn
              class="multi-switch-btn button-hover"
              icon
              @click="openDialogFilterSite"
              title="Filter Site"
            >
              <img src="@/assets/tables/filter-icon.svg" />
            </v-btn>
            <v-btn
              class="multi-switch-btn button-hover multi-switch-size"
              icon
              @click="toggleMultiSite"
            >
              <img src="@/assets/pages/multiple-sites/switch-table.svg" />
            </v-btn>
          </div>
          <div class="google-map-thailand">
            <GmapMap
              ref="mySitesMap"
              :center="mapCenter"
              :zoom="mapZoom"
              :options="{
                styles: [
                  {
                    stylers: [
                      { saturation: -50 },
                    ],
                  },
                ],
                clickableIcons: false,
              }"
            >
              <template v-if="dataForm && dataForm.sites">
                <GmapCluster :zoomOnClick="true" :styles="clusterStyles">
                  <GmapMarker
                    :key="index"
                    v-for="(item, index) in dataForm.sites"
                    :position="{lat: parseFloat(item.latitude), lng: parseFloat(item.longitude)}"
                    :icon="markerIconOptions(item.status, index)"
                    @click="getSiteInformation(item, index)"
                  />
                </GmapCluster>
              </template>
            </GmapMap>
          </div>
        </div>
      </div>
    </div>
    <v-dialog
      v-model="dialogAddSite"
      persistent
      content-class="custom-content-modals custom-scroll-modals"
      max-width="756"
    >
      <v-card>
        <v-card-title>Add New Site</v-card-title>
        <v-card-text class="custom-asset-card">
          <v-form
            ref="addForm"
            @submit.prevent="submitAdd"
            autocomplete="off"
          >
            <div class="scroll_dialog_form">
              <v-row no-gutters>
                <v-col cols="12" md="3" class="modal-label">
                  <span>Global</span>
                </v-col>
                <v-col cols="12" md="9">
                  <v-select
                    ref="siteGlobalSelect"
                    :items="listGlobals"
                    v-model="siteGlobal"
                    :rules="siteGlobalRules"
                    item-text="name"
                    item-value="id"
                    :class="`${siteGlobal ? 'custom-hidden-input' : ''}`"
                    class="custom-select__selections"
                    required
                    filled
                    :menu-props="{ bottom: true, offsetY: true, contentClass: 'custom_active_item' }"
                    append-icon="fas fa-caret-down"
                    placeholder="Select Global"
                    @change="handleChangeGlobal(siteGlobal)"
                  ></v-select>
                </v-col>
              </v-row>
              <v-row no-gutters class="pt-2">
                <v-col cols="12" md="3" class="modal-label">
                  <span>Regional</span>
                </v-col>
                <v-col cols="12" md="9">
                  <v-select
                    ref="siteRegionalSelect"
                    :items="listRegionals"
                    v-model="siteRegional"
                    :rules="siteRegionalRules"
                    item-text="name"
                    item-value="id"
                    :class="`${siteRegional ? 'custom-hidden-input' : ''}`"
                    class="custom-select__selections"
                    required
                    filled
                    :menu-props="{ bottom: true, offsetY: true, contentClass: 'custom_active_item' }"
                    append-icon="fas fa-caret-down"
                    placeholder="Select Regional"
                    @change="handleChangeRegional(siteRegional)"
                  ></v-select>
                </v-col>
              </v-row>
              <v-row no-gutters class="pt-2">
                <v-col cols="12" md="3" class="modal-label">
                  <span>Area</span>
                </v-col>
                <v-col cols="12" md="9">
                  <v-select
                    ref="siteAreaSelect"
                    :items="listAreas"
                    v-model="siteArea"
                    :rules="siteAreaRules"
                    item-text="name"
                    item-value="id"
                    :class="`${siteArea ? 'custom-hidden-input' : ''}`"
                    class="custom-select__selections"
                    required
                    filled
                    :menu-props="{ bottom: true, offsetY: true, contentClass: 'custom_active_item' }"
                    append-icon="fas fa-caret-down"
                    placeholder="Select Area"
                    @change="handleChangeArea(siteArea)"
                  ></v-select>
                </v-col>
              </v-row>
              <v-row no-gutters class="pt-2">
                <v-col cols="12" md="3" class="modal-label">
                  <span>Project</span>
                </v-col>
                <v-col cols="12" md="9">
                  <v-select
                    ref="siteProjectSelect"
                    :items="listProjects"
                    v-model="siteProject"
                    :rules="siteProjectRules"
                    item-text="name"
                    item-value="id"
                    :class="`${siteProject ? 'custom-hidden-input' : ''}`"
                    class="custom-select__selections"
                    required
                    filled
                    :menu-props="{ bottom: true, offsetY: true, contentClass: 'custom_active_item' }"
                    append-icon="fas fa-caret-down"
                    placeholder="Select Project"
                  ></v-select>
                </v-col>
              </v-row>
              <v-row no-gutters class="pt-2">
                <v-col cols="12" md="3" class="modal-label">
                  <span>Unit</span>
                </v-col>
                <v-col cols="12" md="9">
                  <v-text-field
                    v-model="siteUnit"
                    required
                    autocomplete="off"
                    :rules="siteUnitRules"
                    placeholder="Enter Unit"
                    filled
                    :validate-on-blur="true"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row no-gutters class="pt-2 autocomplete-wrapper">
                <v-col cols="12" md="3" class="modal-label">
                  <span>Address</span>
                </v-col>
                <v-col cols="12" md="9">
                  <gmap-autocomplete
                    :value="siteAddress"
                    id="site_address"
                    class="form-control"
                    placeholder="Enter Address"
                    @place_changed="getAddressData($event)"
                  />
                  <div v-if="!validAddress" class="invalid-address">
                    <p class="message-content">Address is required</p>
                  </div>
                </v-col>
              </v-row>
              <v-row no-gutters class="pt-2">
                <v-col cols="12" md="3" class="modal-label">
                  <span>Tariff</span>
                </v-col>
                <v-col cols="12" md="9">
                  <v-select
                    ref="siteTariffSelect"
                    :items="listTariffs"
                    v-model="siteTariff"
                    :rules="siteTariffRules"
                    item-text="name"
                    item-value="key"
                    :class="`${siteTariff ? 'custom-hidden-input' : ''}`"
                    class="custom-select__selections"
                    required
                    filled
                    :menu-props="{ bottom: true, offsetY: true, contentClass: 'custom_active_item' }"
                    append-icon="fas fa-caret-down"
                    placeholder="Select Tariff Mode"
                  ></v-select>
                </v-col>
              </v-row>
              <v-row no-gutters class="pt-2">
                <v-col cols="12" md="3" class="modal-label">
                  <span>Site ID</span>
                </v-col>
                <v-col cols="12" md="9">
                  <v-text-field
                    required
                    autocomplete="off"
                    placeholder="(Auto Generate)"
                    filled
                    :validate-on-blur="true"
                    class="custom_read_only_input"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row no-gutters class="pt-2">
                <v-col cols="12" md="3" class="modal-label">
                  <span>Site Name</span>
                </v-col>
                <v-col cols="12" md="9">
                  <v-text-field
                    v-model="siteName"
                    required
                    autocomplete="off"
                    :rules="siteNameRules"
                    placeholder="Enter Site Name"
                    filled
                    :validate-on-blur="true"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row no-gutters class="pt-2">
                <v-col cols="12" md="3" class="modal-label">
                  <span>Assign Installer</span>
                </v-col>
                <v-col cols="12" md="9">
                  <v-select
                    ref="assignInstallerSelect"
                    :items="assignInstallersList"
                    v-model="assignInstaller"
                    :rules="assignInstallerRules"
                    item-text="username"
                    item-value="id"
                    :class="`${assignInstaller.length ? 'custom-hidden-input' : ''}`"
                    class="custom-select__selections disabled_input"
                    required
                    filled
                    :menu-props="{ top: true, offsetY: true, contentClass: 'custom_active_item' }"
                    append-icon="fas fa-caret-down"
                    placeholder="Select Installer"
                    multiple
                    chips
                  >
                    <template v-slot:selection="{ item, index }">
                      <v-chip v-if="index < 2">
                        <span>{{ item.username }}</span>
                      </v-chip>
                      <span
                        v-if="index === 2"
                        class="text-grey text-caption align-self-center"
                      >
                        (+{{ assignInstaller.length - 2 }} others)
                      </span>
                    </template>
                    <template v-slot:prepend-item>
                      <v-list-item class="customize_v-list-item">
                        <v-list-item-content>
                          <v-text-field v-model="searchTerm" placeholder="Search Installer" @input="searchInstallers"></v-text-field>
                        </v-list-item-content>
                      </v-list-item>
                    </template>
                  </v-select>
                </v-col>
              </v-row>
            </div>
            <v-row no-gutters class="mt-3 pt-2">
              <v-spacer></v-spacer>
              <v-col cols="12" class="text-center">
                <button
                  class="dialog-default-button dialog-button-add-size dialog-bg-outline-button"
                  :ripple="false"
                  type="button"
                  @click="closeDialogAddSite"
                >
                  CANCEL
                </button>
                <button
                  class="ml-4 dialog-default-button dialog-button-add-size dialog-bg-grey-button"
                  :ripple="false"
                  type="submit"
                >
                  CONFIRM
                </button>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="dialogAddProject"
      persistent
      content-class="custom-content-modals"
      max-width="756"
    >
      <v-card>
        <v-card-title>Add New Project</v-card-title>
        <v-card-text class="custom-asset-card">
          <v-form
            ref="addProjectForm"
            @submit.prevent="submitAddProject"
            autocomplete="off"
          >
            <v-row no-gutters>
              <v-col cols="12" md="3" class="modal-label">
                <span>Global</span>
              </v-col>
              <v-col cols="12" md="9">
                <v-select
                  ref="siteGlobalSelect2"
                  :items="listGlobals"
                  v-model="siteGlobal"
                  :rules="siteGlobalRules"
                  item-text="name"
                  item-value="id"
                  :class="`${siteGlobal ? 'custom-hidden-input' : ''}`"
                  class="custom-select__selections"
                  required
                  filled
                  :menu-props="{ bottom: true, offsetY: true, contentClass: 'custom_active_item' }"
                  append-icon="fas fa-caret-down"
                  placeholder="Select Global"
                  @change="handleChangeGlobal(siteGlobal)"
                ></v-select>
              </v-col>
            </v-row>
            <v-row no-gutters class="pt-2">
              <v-col cols="12" md="3" class="modal-label">
                <span>Regional</span>
              </v-col>
              <v-col cols="12" md="9">
                <v-select
                  ref="siteRegionalSelect2"
                  :items="listRegionals"
                  v-model="siteRegional"
                  :rules="siteRegionalRules"
                  item-text="name"
                  item-value="id"
                  :class="`${siteRegional ? 'custom-hidden-input' : ''}`"
                  class="custom-select__selections"
                  required
                  filled
                  :menu-props="{ bottom: true, offsetY: true, contentClass: 'custom_active_item' }"
                  append-icon="fas fa-caret-down"
                  placeholder="Select Regional"
                  @change="handleChangeRegional(siteRegional)"
                ></v-select>
              </v-col>
            </v-row>
            <v-row no-gutters class="pt-2">
              <v-col cols="12" md="3" class="modal-label">
                <span>Area</span>
              </v-col>
              <v-col cols="12" md="9">
                <v-select
                  ref="siteAreaSelect2"
                  :items="listAreas"
                  v-model="siteArea"
                  :rules="siteAreaRules"
                  item-text="name"
                  item-value="id"
                  :class="`${siteArea ? 'custom-hidden-input' : ''}`"
                  class="custom-select__selections"
                  required
                  filled
                  :menu-props="{ bottom: true, offsetY: true, contentClass: 'custom_active_item' }"
                  append-icon="fas fa-caret-down"
                  placeholder="Select Area"
                ></v-select>
              </v-col>
            </v-row>
            <v-row no-gutters class="pt-2">
              <v-col cols="12" md="3" class="modal-label">
                <span>Project</span>
              </v-col>
              <v-col cols="12" md="9">
                <v-text-field
                  v-model="projectName"
                  required
                  autocomplete="off"
                  :rules="projectRules"
                  placeholder="Enter Project"
                  filled
                  :validate-on-blur="true"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row no-gutters class="mt-3 pt-2">
              <v-spacer></v-spacer>
              <v-col cols="12" class="text-center">
                <button
                  class="dialog-default-button dialog-button-add-size dialog-bg-outline-button"
                  :ripple="false"
                  type="button"
                  @click="closeDialogAddProject"
                >
                  CANCEL
                </button>
                <button
                  class="ml-4 dialog-default-button dialog-button-add-size dialog-bg-grey-button"
                  :ripple="false"
                  type="submit"
                >
                  CONFIRM
                </button>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="dialogEditSite"
      persistent
      content-class="custom-content-modals custom-scroll-modals"
      max-width="756"
    >
      <v-card>
        <v-card-title>Edit Site</v-card-title>
        <v-card-text class="custom-asset-card">
          <v-form
            ref="editForm"
            @submit.prevent="submitEdit"
            autocomplete="off"
          >
            <div class="scroll_dialog_form">
              <v-row no-gutters>
                <v-col cols="12" md="3" class="modal-label">
                  <span>Global</span>
                </v-col>
                <v-col cols="12" md="9">
                  <v-select
                    ref="editSiteGlobalSelect"
                    :items="listGlobals"
                    v-model="editSiteGlobal"
                    :rules="siteGlobalRules"
                    item-text="name"
                    item-value="id"
                    :class="`${editSiteGlobal ? 'custom-hidden-input' : ''}`"
                    class="custom-select__selections"
                    required
                    filled
                    :menu-props="{ bottom: true, offsetY: true, contentClass: 'custom_active_item' }"
                    append-icon="fas fa-caret-down"
                    placeholder="Select Global"
                    @change="handleChangeGlobalEdit(editSiteGlobal)"
                  ></v-select>
                </v-col>
              </v-row>
              <v-row no-gutters class="pt-2">
                <v-col cols="12" md="3" class="modal-label">
                  <span>Regional</span>
                </v-col>
                <v-col cols="12" md="9">
                  <v-select
                    ref="editSiteRegionalSelect"
                    :items="listRegionals"
                    v-model="editSiteRegional"
                    :rules="siteRegionalRules"
                    item-text="name"
                    item-value="id"
                    :class="`${editSiteRegional ? 'custom-hidden-input' : ''}`"
                    class="custom-select__selections"
                    required
                    filled
                    :menu-props="{ bottom: true, offsetY: true, contentClass: 'custom_active_item' }"
                    append-icon="fas fa-caret-down"
                    placeholder="Select Regional"
                    @change="handleChangeRegionalEdit(editSiteRegional)"
                  ></v-select>
                </v-col>
              </v-row>
              <v-row no-gutters class="pt-2">
                <v-col cols="12" md="3" class="modal-label">
                  <span>Area</span>
                </v-col>
                <v-col cols="12" md="9">
                  <v-select
                    ref="editSiteAreaSelect"
                    :items="listAreas"
                    v-model="editSiteArea"
                    :rules="siteAreaRules"
                    item-text="name"
                    item-value="id"
                    :class="`${editSiteArea ? 'custom-hidden-input' : ''}`"
                    class="custom-select__selections"
                    required
                    filled
                    :menu-props="{ bottom: true, offsetY: true, contentClass: 'custom_active_item' }"
                    append-icon="fas fa-caret-down"
                    placeholder="Select Area"
                    @change="handleChangeAreaEdit(editSiteArea)"
                  ></v-select>
                </v-col>
              </v-row>
              <v-row no-gutters class="pt-2">
                <v-col cols="12" md="3" class="modal-label">
                  <span>Project</span>
                </v-col>
                <v-col cols="12" md="9">
                  <v-select
                    ref="editSiteProjectSelect"
                    :items="listProjects"
                    v-model="editSiteProject"
                    :rules="siteProjectRules"
                    item-text="name"
                    item-value="id"
                    :class="`${editSiteProject ? 'custom-hidden-input' : ''}`"
                    class="custom-select__selections"
                    required
                    filled
                    :menu-props="{ bottom: true, offsetY: true, contentClass: 'custom_active_item' }"
                    append-icon="fas fa-caret-down"
                    placeholder="Select Project"
                  ></v-select>
                </v-col>
              </v-row>
              <v-row no-gutters class="pt-2" style="pointer-events: none;">
                <v-col cols="12" md="3" class="modal-label">
                  <span>Unit</span>
                </v-col>
                <v-col cols="12" md="9">
                  <v-text-field
                    v-model="editSiteUnit"
                    required
                    autocomplete="off"
                    :rules="siteUnitRules"
                    placeholder="Enter Unit"
                    filled
                    :validate-on-blur="true"
                    disabled
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row no-gutters class="pt-2 autocomplete-wrapper">
                <v-col cols="12" md="3" class="modal-label">
                  <span>Address</span>
                </v-col>
                <v-col cols="12" md="9">
                  <gmap-autocomplete
                    :value="editSiteAddress"
                    id="site_address"
                    class="form-control"
                    placeholder="Enter Address"
                    @place_changed="getAddressDataEdit($event)"
                  />
                  <div v-if="!validAddress" class="invalid-address">
                    <p class="message-content">Address is required</p>
                  </div>
                </v-col>
              </v-row>
              <v-row no-gutters class="pt-2">
                <v-col cols="12" md="3" class="modal-label">
                  <span>Tariff</span>
                </v-col>
                <v-col cols="12" md="9">
                  <v-select
                    ref="editSiteTariffSelect"
                    :items="listTariffs"
                    v-model="editSiteTariff"
                    :rules="siteTariffRules"
                    item-text="name"
                    item-value="key"
                    :class="`${editSiteTariff ? 'custom-hidden-input' : ''}`"
                    class="custom-select__selections"
                    required
                    filled
                    :menu-props="{ bottom: true, offsetY: true, contentClass: 'custom_active_item' }"
                    append-icon="fas fa-caret-down"
                    placeholder="Select Tariff Mode"
                  ></v-select>
                </v-col>
              </v-row>
              <v-row no-gutters class="pt-2">
                <v-col cols="12" md="3" class="modal-label">
                  <span>Site ID</span>
                </v-col>
                <v-col cols="12" md="9">
                  <v-text-field
                    v-model="editSiteId"
                    required
                    autocomplete="off"
                    placeholder="(Auto Generate)"
                    filled
                    :validate-on-blur="true"
                    class="custom_read_only_input"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row no-gutters class="pt-2">
                <v-col cols="12" md="3" class="modal-label">
                  <span>Site Name</span>
                </v-col>
                <v-col cols="12" md="9">
                  <v-text-field
                    v-model="editSiteName"
                    required
                    autocomplete="off"
                    :rules="siteNameRules"
                    placeholder="Enter Site Name"
                    filled
                    :validate-on-blur="true"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row no-gutters class="pt-2">
                <v-col cols="12" md="3" class="modal-label">
                  <span>Assign Installer</span>
                </v-col>
                <v-col cols="12" md="9">
                  <v-select
                    ref="editAssignInstallerSelect"
                    :items="assignInstallersList"
                    v-model="editAssignInstaller"
                    :rules="assignInstallerRules"
                    item-text="username"
                    item-value="id"
                    :class="`${editAssignInstaller.length ? 'custom-hidden-input' : ''}`"
                    class="custom-select__selections disabled_input"
                    required
                    filled
                    :menu-props="{ top: true, offsetY: true, contentClass: 'custom_active_item' }"
                    append-icon="fas fa-caret-down"
                    placeholder="Select Installer"
                    multiple
                    chips
                  >
                    <template v-slot:selection="{ item, index }">
                      <v-chip v-if="index < 2">
                        <span>{{ item.username }}</span>
                      </v-chip>
                      <span
                        v-if="index === 2"
                        class="text-grey text-caption align-self-center"
                      >
                        (+{{ editAssignInstaller.length - 2 }} others)
                      </span>
                    </template>
                    <template v-slot:prepend-item>
                      <v-list-item class="customize_v-list-item">
                        <v-list-item-content>
                          <v-text-field v-model="searchTerm" placeholder="Search Installer" @input="searchInstallers"></v-text-field>
                        </v-list-item-content>
                      </v-list-item>
                    </template>
                  </v-select>
                </v-col>
              </v-row>
            </div>
            <v-row no-gutters class="mt-3 pt-2">
              <v-spacer></v-spacer>
              <v-col cols="12" class="text-center">
                <button
                  class="dialog-default-button dialog-button-add-size dialog-bg-outline-button"
                  :ripple="false"
                  type="button"
                  @click="closeDialogEditSite"
                >
                  CANCEL
                </button>
                <button
                  class="ml-4 dialog-default-button dialog-button-add-size dialog-bg-grey-button"
                  :ripple="false"
                  type="submit"
                >
                  CONFIRM
                </button>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="dialogFilterSite"
      persistent
      content-class="custom-content-modals"
      max-width="1019"
    >
      <v-card>
        <v-card-title class="v-card__title-filter">Filter</v-card-title>
        <v-card-text class="custom-asset-card v-card__text-filter">
          <v-form
            ref="filterSiteForm"
            @submit.prevent="submitFilter"
            autocomplete="off"
          >
            <v-row no-gutters>
              <v-col cols="5" md="5" class="filter-col-5">
                <p class="filter-name text-light mb-3">Global/Regional/Area/Project</p>
                <div class="menu-tree-wrapper">
                  <div class="tree-node text-light" v-for="(globalItem, index) in listGlobalsFilter" :key="index">
                    <div
                      class="tree-node-content"
                      :id="'toggle-' + index"
                    >
                      <div 
                        v-if="globalItem.regionals.length" 
                        class="icons-wrap" 
                        v-b-toggle="'collapse-' + index" 
                        @click="renderCollapseIcon(globalItem)"
                      >
                        <span v-show="globalItem.collapse">
                          <i class="fas fa-minus"></i>
                        </span>
                        <span v-show="!globalItem.collapse">
                          <i class="fas fa-plus"></i>
                        </span>
                      </div>
                      <div class="option-item mb-0">
                        <input v-model="globalItem.isChecked" class="cursor-pointer" type="checkbox" :id="'input-' + index" :name="'input-' + index" :value="globalItem.name" />
                        <label :for="'input-' + index">{{ globalItem.name }}</label>
                      </div>
                    </div>
                    <b-collapse :id="'collapse-' + index" @shown="handleCollapseChecked(globalItem)">
                      <div class="tree-node">
                        <div v-for="(regionalItem, subIndex) in globalItem.regionals" class="tree-node" :key="subIndex">
                          <div
                            class="tree-node-content"
                            :id="'toggle-' + index + '-' + subIndex"
                          >
                            <div 
                              v-if="regionalItem.areas.length" 
                              class="icons-wrap" 
                              v-b-toggle="'collapse-' + index + '-' + subIndex" 
                              @click="renderCollapseIcon(regionalItem)"
                            >
                              <span v-show="regionalItem.collapse">
                                <i class="fas fa-minus"></i>
                              </span>
                              <span v-show="!regionalItem.collapse">
                                <i class="fas fa-plus"></i>
                              </span>
                            </div>
                            <div class="option-item mb-0">
                              <input v-model="regionalItem.isChecked" class="cursor-pointer" type="checkbox" :id="'input-' + index + '-' + subIndex" :name="'input-' + index + '-' + subIndex" :value="regionalItem.name" />
                              <label :for="'input-' + index + '-' + subIndex">{{ regionalItem.name }}</label>
                            </div>
                          </div>
                          <b-collapse :id="'collapse-' + index + '-' + subIndex" @shown="handleCollapseChecked(regionalItem)">
                            <div class="tree-node">
                              <div v-for="(areaItem, subSubIndex) in regionalItem.areas" class="tree-node" :key="subSubIndex">
                                <div
                                  class="tree-node-content"
                                  :id="'toggle-' + index + '-' + subIndex + '-' + subSubIndex"
                                >
                                  <div 
                                    v-if="areaItem.projects.length" 
                                    class="icons-wrap" 
                                    v-b-toggle="'collapse-' + index + '-' + subIndex + '-' + subSubIndex" 
                                    @click="renderCollapseIcon(areaItem)"
                                  >
                                    <span v-show="areaItem.collapse">
                                      <i class="fas fa-minus"></i>
                                    </span>
                                    <span v-show="!areaItem.collapse">
                                      <i class="fas fa-plus"></i>
                                    </span>
                                  </div>
                                  <div class="option-item mb-0">
                                    <input v-model="areaItem.isChecked" class="cursor-pointer" type="checkbox" :id="'input-' + index + '-' + subIndex + '-' + subSubIndex" :name="'input-' + index + '-' + subIndex + '-' + subSubIndex" :value="areaItem.name" />
                                    <label :for="'input-' + index + '-' + subIndex + '-' + subSubIndex">{{ areaItem.name }}</label>
                                  </div>
                                </div>
                                <b-collapse :id="'collapse-' + index + '-' + subIndex + '-' + subSubIndex" @shown="handleCollapseChecked(areaItem)">
                                  <div class="tree-node">
                                    <div v-for="(projectItem, subSubSubIndex) in areaItem.projects" class="tree-node" :key="subSubSubIndex">
                                      <div 
                                        class="tree-node-content"
                                        :id="'toggle-' + index + '-' + subIndex + '-' + subSubIndex + '-' + subSubSubIndex"
                                      >
                                        <div class="option-item mb-0">
                                          <input v-model="projectItem.isChecked" class="cursor-pointer" type="checkbox" :id="'input-' + index + '-' + subIndex + '-' + subSubIndex + '-' + subSubSubIndex" :name="'input-' + index + '-' + subIndex + '-' + subSubIndex + '-' + subSubSubIndex" :value="projectItem.name" />
                                          <label :for="'input-' + index + '-' + subIndex + '-' + subSubIndex + '-' + subSubSubIndex">{{ projectItem.name }}</label>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </b-collapse>
                              </div>
                            </div>
                          </b-collapse>
                        </div>
                      </div>
                    </b-collapse>
                  </div>
                </div>
              </v-col>
              <v-col cols="7" md="7" class="filter-col-7">
                <v-row no-gutters>
                  <v-col cols="12" md="12" class="text-light">
                    <p class="filter-name">Installed DER</p>
                    <v-row no-gutters class="checkboxes-row">
                      <v-col cols="4">
                        <div class="option-item">
                          <input v-model="selectedInstalledDer" class="cursor-pointer" type="checkbox" id="pv-installed" name="pv-installed" value="pv_installed" />
                          <label for="pv-installed">PV Inverter</label>
                        </div>
                      </v-col>
                      <v-col cols="4">
                        <div class="option-item">
                          <input v-model="selectedInstalledDer" class="cursor-pointer" type="checkbox" id="bess-installed" name="bess-installed" value="bess_installed" />
                          <label for="bess-installed">BESS</label>
                        </div>
                      </v-col>
                      <v-col cols="4">
                        <div class="option-item">
                          <input v-model="selectedInstalledDer" class="cursor-pointer" type="checkbox" id="evse-installed" name="evse-installed" value="evse_installed" />
                          <label for="evse-installed">EVSE</label>
                        </div>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col cols="12" md="12" class="text-light">
                    <p class="filter-name">Site Status</p>
                    <v-row no-gutters class="checkboxes-row">
                      <v-col cols="4">
                        <div class="option-item">
                          <input v-model="selectedSiteStatuses" class="cursor-pointer" type="checkbox" id="normal-status" name="normal-status" value="normal" />
                          <label for="normal-status">Normal</label>
                        </div>
                      </v-col>
                      <v-col cols="4">
                        <div class="option-item">
                          <input v-model="selectedSiteStatuses" class="cursor-pointer" type="checkbox" id="alarm-status" name="alarm-status" value="alarm" />
                          <label for="alarm-status">Alarm</label>
                        </div>
                      </v-col>
                      <v-col cols="4">
                        <div class="option-item">
                          <input v-model="selectedSiteStatuses" class="cursor-pointer" type="checkbox" id="offline-status" name="offline-status" value="offline" />
                          <label for="offline-status">Offline</label>
                        </div>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col cols="12" md="12" class="text-light">
                    <p class="filter-name">Commissioned Date</p>
                    <v-row no-gutters class="checkboxes-row commissioned-date-row">
                      <v-col cols="1" md="1" class="date-picker-title">
                        <p>From</p>
                      </v-col>
                      <v-col cols="3" md="3" class="date-picker-table">
                        <v-menu
                          ref="commissionedDateMenu"
                          v-model="commissionedDateMenu"
                          :close-on-content-click="false"
                          transition="scale-transition"
                          offset-y
                          max-width="332"
                          min-width="auto"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              v-model="commissionedDateTextFrom"
                              readonly
                              v-bind="attrs"
                              v-on="on"
                              append-icon="fas fa-caret-down"
                              class="date-picker-text-field"
                            >
                            </v-text-field>
                          </template>
                          <v-date-picker
                            flat
                            v-model="commissionedDateRange"
                            no-title
                            range
                            width="auto"
                            first-day-of-week="0"
                            type="date"
                            :min="rangeMinDate"
                            :max="rangeMaxDate"
                            :dark="true"
                            class="customize_commissioned_date_picker"
                            @input="closeCommissionedDateMenu"
                          ></v-date-picker>
                        </v-menu>
                      </v-col>
                      <v-col cols="1" md="1" class="date-picker-title">
                        <p style="margin-left: 13px;">To</p>
                      </v-col>
                      <v-col cols="3" md="3" class="date-picker-table">
                        <v-text-field
                          v-model="commissionedDateTextTo"
                          readonly
                          append-icon="fas fa-caret-down"
                          class="date-picker-text-field"
                          @click="openCommissionedDateMenu"
                        >
                        </v-text-field>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
                <v-row no-gutters class="filter-buttons-row">
                  <v-spacer></v-spacer>
                  <v-col cols="12" class="text-center">
                    <button
                      class="dialog-default-button button-filter-site-size dialog-bg-outline-button"
                      :ripple="false"
                      type="button"
                      @click="closeDialogFilterSite"
                    >
                      CANCEL
                    </button>
                    <button
                      class="ml-4 dialog-default-button button-filter-site-size dialog-bg-outline-button"
                      :ripple="false"
                      type="button"
                      @click="resetDialogFilterSite"
                    >
                      RESET
                    </button>
                    <button
                      class="ml-4 dialog-default-button button-filter-site-size dialog-bg-grey-button"
                      :ripple="false"
                      type="submit"
                    >
                      APPLY
                    </button>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="messageDialog"
      max-width="500"
      content-class="confirm-dialog-box"
    >
      <v-card>
        <v-card-title class="justify-content-center">{{ apiTitle }}</v-card-title>
        <v-card-text
          ><v-row no-gutters>
            <v-col cols="12" class="text-center">
              <span v-html="apiMessage"></span>
            </v-col>
            <v-col cols="12" class="dialog-buttons-padding text-center">
              <button
                class="dialog-default-button dialog-button-confirm-size dialog-bg-grey-button"
                type="button"
                :ripple="false"
                @click="closeMessage"
              >
                OK
              </button>
            </v-col>
          </v-row></v-card-text
        >
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="confirmDialog"
      persistent
      max-width="672"
      content-class="confirm-dialog-box"
    >
      <v-card>
        <v-card-title>{{ dialogHeading }}</v-card-title>
        <v-card-text>
          <v-row no-gutters>
            <v-col cols="12" class="dialog-content">
              <span>{{ dialogMessage }}</span>
            </v-col>
            <v-col cols="12" class="dialog-buttons-padding text-center">
              <button
                class="dialog-default-button dialog-button-confirm-size dialog-bg-outline-button"
                type="button"
                :ripple="false"
                @click="closeConfirmDialog"
              >
                CANCEL
              </button>
              <button
                class="ml-4 dialog-default-button dialog-button-confirm-size dialog-bg-grey-button"
                type="button"
                :ripple="false"
                @click="dialogAction(siteItem)"
              >
                CONFIRM
              </button>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<style lang="scss" src="@/assets/css/multiple-sites-information.scss"></style>
<script>
import { siteService, multipleSitesService } from "@/services";
import moment from "moment";
import GmapCluster from 'vue2-google-maps/src/components/cluster';

const normalMarker = require("@/assets/markers/normal_marker.svg");
const offlineMarker = require("@/assets/markers/offline_marker.svg");
const alarmMarker = require("@/assets/markers/alarm_marker.svg");
const activeMarker = require("@/assets/markers/active_marker.svg");
const blueCluster = require("@/assets/markers/blue_cluster.png");

export default {
  props: ['multiSiteToggle'],
  components: { 
    GmapCluster
  },
  data() {
    return {
      dataForm: null,
      series: [],
      siteInfo: null,
      mapCenter: { lat: 0, lng: 0 },
      mapZoom: 0,
      normalMarker: normalMarker,
      offlineMarker: offlineMarker,
      alarmMarker: alarmMarker,
      activeMarker: activeMarker,
      imageStatus: {
        'normal':  normalMarker,
        'offline' : offlineMarker,
        'alarm' : alarmMarker,
        'active' : activeMarker,
      },
      mapOptions: {
        center: { lat: 0, lng: 0 },
        zoom: 14,
      },
      selectedMarkerIndex: null,
      dialogAddSite: false,
      messageDialog: false,
      apiMessage: "",
      apiTitle: "",
      confirmDialog: false,
      siteItem: {},
      dialogAction: () => null,
      dialogHeading: "",
      dialogMessage: "",
      listGlobals: [],
      listRegionals: [],
      listAreas: [],
      listProjects: [],
      siteGlobal: "",
      siteRegional: "",
      siteArea: "",
      siteProject: "",
      siteUnit: "",
      siteAddress: "",
      latitude: null,
      longitude: null,
      timeZone: null,
      editTimeZone: null,
      // siteCurrency: "",
      // siteImage: null,
      siteName: "",
      assignInstallersList: [],
      assignInstaller: [],
      dialogEditSite: false,
      editSiteGlobal: "",
      editSiteRegional: "",
      editSiteArea: "",
      editSiteProject: "",
      editSiteUnit: "",
      editSiteAddress: "",
      editSiteId: "",
      editSiteName: "",
      editAssignInstaller: [],
      editLatitude: null,
      editLongitude: null,
      // editSiteCurrency: "",
      // editSiteImage: null,
      validAddress: true,
      searchSite: "",
      searchSiteTimeout: null,
      listGlobalsFilter: [],
      dialogFilterSite: false,
      selectedSiteStatuses: [],
      commissionedDateMenu: false,
      commissionedDateRange: [],
      selectedInstalledDer: [],
      selectedGlobals: [],
      selectedRegionals: [],
      selectedAreas: [],
      selectedProjects: [],
      dataSearch: {},
      dialogAddProject: false,
      projectName: "",
      siteTariff: "",
      editSiteTariff: "",
      listTariffs: [
        {
          key: "tou",
          name: "TOU",
        },
        {
          key: "flat",
          name: "Flat",
        },
      ],
      siteGlobalRules: [
        (v) => !!v || "Global is required",
      ],
      siteRegionalRules: [
        (v) => !!v || "Regional is required",
      ],
      siteAreaRules: [
        (v) => !!v || "Area is required",
      ],
      siteProjectRules: [
        (v) => !!v || "Project is required",
      ],
      projectRules: [
        (v) => !!v || "Project is required",
        (v) => (v && v.length <= 50) || "Project must be at most 50 characters",
      ],
      // siteCurrencyRules: [
      //   (v) => !!v || "Currency is required",
      // ],
      // siteImageRules: [
      //   (v) => !!v || "Site Image is required",
      //   (v) => !v || ['image/jpeg', 'image/png', 'image/jpg'].includes(v.type) || "Only jpeg, png or jpg files are allowed",
      //   (v) => !v || (v.size / 1024 / 1024) <= 2 || "Site Image size must be less than 2MB",
      // ],
      // editsSiteImageRules: [
      //   (v) => !v || ['image/jpeg', 'image/png', 'image/jpg'].includes(v.type) || "Only jpeg, png or jpg files are allowed",
      //   (v) => !v || (v.size / 1024 / 1024) <= 2 || "Site Image size must be less than 2MB",
      // ],
      siteUnitRules: [
        (v) => !!v || "Unit is required",
      ],
      siteNameRules: [
        (v) => !!v || "Site Name is required",
        (v) => (v && v.length <= 50) || "Site Name must be at most 50 characters",
      ],
      assignInstallerRules: [
        (v) =>!!v.length || "Assign Installer is required",
      ],
      siteTariffRules: [
        (v) => !!v || "Tariff Mode is required",
      ],
      searchTerm: "",
      // searchCurrencyTerm: "",
      installersListCopy: [],
      currenciesListCopy: [],
      lastMouseEvent: null,
      selectMenuList: [
        "siteGlobalSelect", 
        "siteGlobalSelect2", 
        "siteRegionalSelect", 
        "siteRegionalSelect2", 
        "siteAreaSelect", 
        "siteAreaSelect2", 
        "siteProjectSelect", 
        "assignInstallerSelect", 
        "editSiteGlobalSelect", 
        "editSiteRegionalSelect", 
        "editSiteAreaSelect", 
        "editSiteProjectSelect", 
        "editAssignInstallerSelect",
        "siteTariffSelect",
        "editSiteTariffSelect",
      ],
      clusterStyles: [
        {
          url: blueCluster,
          height: 53,
          width: 53,
        },
      ],
    };
  },
  mounted() {
    this.addCenterMapButton();
    document.addEventListener('mousemove', this.onMouseMove);
    document.addEventListener('scroll', this.onScroll, true);
  },
  beforeDestroy() {
    document.removeEventListener('mousemove', this.onMouseMove);
    document.removeEventListener('scroll', this.onScroll, true);
  },
  watch: {
    'dataForm.sites': {
      handler () {
        this.handleTilesLoaded();
      },
      deep: true,
    },
  },
  async created() {
    await this.getMultipleSites();
    if(this.dataForm && this.dataForm.count){
      this.series = Object.keys(this.dataForm.count).map(key => this.dataForm.count[key]);
    }
    this.getListGlobals();
    await this.getListAssignInstallers();
    this.addFieldsMenuTree();
    if (this.assignInstallersList?.length) {
      this.installersListCopy = [...this.assignInstallersList];
    }
    if (this.LIST_CURRENCIES?.length) {
      this.currenciesListCopy = [...this.LIST_CURRENCIES];
    }
  },
  computed: {
    user: function () {
      return this.$store.getters.user;
    },
    accessibleRoutes: function () {
      return this.$store.getters.accessibleRoutes;
    },
    commissionedDateTextFrom () {
      if(this.commissionedDateRange && this.commissionedDateRange.length > 0){
        return `${this.commissionedDateRange[0] ? moment(this.commissionedDateRange[0]).format("DD/MM/YYYY") : ''}`;
      }
      return null;
    },
    commissionedDateTextTo () {
      if(this.commissionedDateRange && this.commissionedDateRange.length > 1){
        return `${this.commissionedDateRange[1] ? moment(this.commissionedDateRange[1]).format("DD/MM/YYYY") : ''}`;
      }
      return null;
    },
    rangeMinDate() {
      const minDate = this.commissionedDateRange?.length === 1 ? this.commissionedDateRange[0] : null;
      return minDate;
    },
    rangeMaxDate() {
      const maxDate = this.NOW_DATE().format(this.DATE_PICKER_FORMAT);
      return maxDate;
    },
  },
  methods: {
    createCenterMap() {
      const controlButton = document.createElement("button");
      controlButton.style.backgroundColor = "#fff";
      controlButton.style.borderRadius = "3px";
      controlButton.style.boxShadow = "0 2px 6px rgba(0,0,0,.3)";
      controlButton.style.color = "#565656";
      controlButton.style.cursor = "pointer";
      controlButton.style.fontFamily = "Roboto,Arial,sans-serif";
      controlButton.style.fontSize = "18px";
      controlButton.style.lineHeight = "40px";
      controlButton.style.margin = "9px 0";
      controlButton.style.padding = "0 5px";
      controlButton.style.textAlign = "center";
      controlButton.textContent = "Center Map";
      controlButton.title = "Click to recenter the map";
      controlButton.type = "button";
      controlButton.addEventListener("click", () => {
        this.fitBounds();
      });
      return controlButton;
    },
    addCenterMapButton() {
      this.$gmapApiPromiseLazy().then((google) => {
        const map = this.$refs.mySitesMap.$mapObject;
        const centerControlDiv = document.createElement("div");
        const centerControl = this.createCenterMap();
        centerControlDiv.appendChild(centerControl);
        map.controls[google.maps.ControlPosition.TOP_CENTER].push(centerControlDiv);
      });
    },
    onMouseMove(event) {
      this.handleMouseMove(event, this);
    },
    onScroll() {
      this.handleScroll(this.selectMenuList, this);
    },
    handleTilesLoaded() {
      this.fitBounds();
    },
    fitBounds() {
      this.$gmapApiPromiseLazy().then((google) => {
        const bounds = new google.maps.LatLngBounds();
        this.dataForm.sites.forEach((marker) => {
          bounds.extend({lat: parseFloat(marker.latitude), lng: parseFloat(marker.longitude)});
        });
        this.$refs.mySitesMap.fitBounds(bounds);
        const map = this.$refs.mySitesMap.$mapObject;
        const maxZoom = 14;
        const zoom = map.getZoom();
        this.mapZoom = Math.min(zoom, maxZoom);
        this.mapCenter = map.getCenter();
      });
    },
    async getMultipleSites(search, filter) {
      const params = { ...search, ...filter };
      await multipleSitesService
        .getMultipleSites(params)
        .then((res) => {
          if (res.status == 200 && res?.data?.data) {
            const dataForm = res.data.data;
            this.dataForm = dataForm ? dataForm : null;
          } else {
            throw res;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    markerIconOptions(status, index) {
      let iconUrl = this.imageStatus[status];
      if (index === this.selectedMarkerIndex) {
        iconUrl = this.imageStatus['active'];
      }

      return {
        url: iconUrl,
        size: { width: 41, height: 41, f: "px", b: "px" },
        scaledSize: { width: 41, height: 41, f: "px", b: "px" }
      };
    },
    toggleMultiSite() {
      const newValue = !this.multiSiteToggle;
      this.$emit('updateMultiSiteToggle', newValue);
    },
    getSiteInformation(data, index) {
      this.siteInfo = data;
      this.selectedMarkerIndex = index;
      this.mapOptions.center = { lat: parseFloat(this.siteInfo.latitude), lng: parseFloat(this.siteInfo.longitude) };
      this.mapCenter = { ...this.mapOptions.center };
      this.mapZoom = this.mapOptions.zoom;
    },
    saveSiteIdCurrent() {
      this.$store.commit('setSiteId', this.siteInfo.id);
      this.$store.commit('setTimeZone', this.siteInfo.timezone);
      // this.$store.commit('setSiteCurrency', this.siteInfo.currency);
      localStorage.setItem('selectedSiteId', this.$store.state.siteId);
      localStorage.setItem('selectedTimeZone', this.$store.state.time_zone);
      // localStorage.setItem('selectedSiteCurrency', this.$store.state.currency);
    },
    openDialogAddSite() {
      this.dialogAddSite = true;
    },
    closeDialogAddSite() {
      this.revertSite();
      this.dialogAddSite = false;
    },
    async submitAdd() {
      this.checkValidAddress("add");
      if (this.$refs.addForm.validate() && this.validAddress) {
        let data = new FormData();
        data.append("name", this.siteName);
        data.append("assign_installer", JSON.stringify(this.assignInstaller));
        data.append("project_id", this.siteProject);
        data.append("unit", this.siteUnit);
        data.append("address", this.siteAddress);
        data.append("latitude", this.latitude);
        data.append("longitude", this.longitude);
        data.append("timezone", this.timeZone);
        data.append("tariff_mode", this.siteTariff);
        // data.append("currency", this.siteCurrency);
        // data.set("image", this.siteImage);
        
        await siteService
          .storeSite(data)
          .then((res) => {
            if (res.status !== 200) throw res;
            this.getMultipleSites();
            this.closeDialogAddSite();
            this.apiMessage = "Site has been successfully added";
            this.apiTitle = "Success";
            this.messageDialog = true;
          })
          .catch((err) => {
            let message = "Site cannot be added";
            if (err?.response?.data?.message) {
              message = err.response.data.message;
            }
            this.apiMessage = message;
            this.apiTitle = "Error";
            this.messageDialog = true;
          });
      }
    },
    revertSite() {
      this.$refs.addForm.reset();
      this.siteAddress = "";
      this.timeZone = null;
      this.longitude = null;
      this.latitude = null;
    },
    closeMessage() {
      this.messageDialog = false;
    },
    deleteSite(item) {
      if (item?.id) {
        siteService
          .deleteSite(item.id)
          .then((res) => {
            if (res.status !== 200 && res.status !== 204) throw res;
            this.siteInfo = null;
            this.closeConfirmDialog();
            this.getMultipleSites();
            this.apiMessage = "Site has been successfully deleted";
            this.apiTitle = "Success";
            this.messageDialog = true;
          })
          .catch((err) => {
            let message = "Site cannot be deleted";
            if (err?.response?.data?.message) {
              message = err.response.data.message;
            }
            this.apiMessage = message;
            this.apiTitle = "Error";
            this.messageDialog = true;
          });
      }
    },
    openConfirmDialog(item, action, heading, message) {
      this.siteItem = Object.assign({}, this.siteItem, item);
      this.dialogAction = action;
      this.dialogHeading = heading;
      this.dialogMessage = message;
      this.confirmDialog = true;
    },
    closeConfirmDialog() {
      this.siteItem = Object.assign({}, this.siteItem);
      this.confirmDialog = false;
      this.dialogAction = () => null;
      this.dialogHeading = "";
      this.dialogMessage = "";
    },
    getListGlobals() {
      return multipleSitesService
        .getListGlobals()
        .then((res) => {
          if (res?.data?.data) {
            const dataSiteGlobals = res.data.data;
            this.listGlobals = [...dataSiteGlobals];
            this.listGlobalsFilter = [...dataSiteGlobals];
            return res;
          }
        })
        .catch(() => {
          return null;
        });
    },
    handleChangeGlobal(global_id) {
      this.listRegionals = [];
      this.siteRegional = "";
      this.listAreas = [];
      this.siteArea = "";
      this.listProjects = [];
      this.siteProject = "";
      const selectedGlobal = this.listGlobals.find(global => global.id === global_id);
      if (selectedGlobal) {
        this.listRegionals = selectedGlobal.regionals;
      }
    },
    handleChangeRegional(regional_id) {
      this.listAreas = [];
      this.siteArea = "";
      this.listProjects = [];
      this.siteProject = "";
      const selectedRegional = this.listRegionals.find(regional => regional.id === regional_id);
      if (selectedRegional) {
        this.listAreas = selectedRegional.areas;
      }
    },
    handleChangeArea(area_id) {
      this.listProjects = [];
      this.siteProject = "";
      const selectedArea = this.listAreas.find(area => area.id === area_id);
      if (selectedArea) {
        this.listProjects = selectedArea.projects;
      }
    },
    async getListAssignInstallers() {
      return await siteService
        .getListAssignInstallers()
        .then((res) => {
          if (res?.data?.data) {
            const dataAssignInstallers = res.data.data;
            this.assignInstallersList = [...dataAssignInstallers];
            return res;
          }
        })
        .catch(() => {
          return null;
        });
    },
    setSiteInfo(data) {
      if (data) {
        this.editSiteGlobal = data.global_id || "";
        this.handleChangeGlobalEdit(this.editSiteGlobal);
        this.editSiteRegional = data.regional_id || "";
        this.handleChangeRegionalEdit(this.editSiteRegional);
        this.editSiteArea = data.area_id || "";
        this.handleChangeAreaEdit(this.editSiteArea);
        this.editSiteProject = data.project_id || "";
        this.editSiteUnit = data.unit || "";
        this.editSiteAddress = data.address || "";
        this.editLatitude = parseFloat(data.latitude) || null;
        this.editLongitude = parseFloat(data.longitude) || null;
        this.editTimeZone = data.timezone || null;
        this.editSiteId = data.id || "";
        this.editSiteName = data.name || "";
        // this.editSiteCurrency = data.currency || "";
        this.editAssignInstaller = data.assign_installer || [];
        this.editSiteTariff = data.tariff_mode || "";
        this.sitesInfo = data;
      } else {
        this.editSiteGlobal = "";
        this.editSiteRegional = "";
        this.editSiteArea = "";
        this.editSiteProject = "";
        this.editSiteUnit = "";
        this.editSiteAddress = "";
        this.editLatitude = null;
        this.editLongitude = null;
        this.editTimeZone = null;
        this.editSiteId = "";
        this.editSiteName = "";
        // this.editSiteCurrency = "";
        this.editAssignInstaller = [];
        this.editSiteTariff = "";
        this.sitesInfo = null;
      }
    },
    openDialogEdit(item) {
      if (item?.id) {
        siteService
          .getSite(item.id)
          .then((res) => {
            if (res?.data?.data) {
              this.setSiteInfo(res.data.data);
              this.dialogEditSite = true;
            }
          })
          .catch();
      }
    },
    closeDialogEditSite() {
      this.setSiteInfo(null);
      this.revertSiteEdit();
      this.dialogEditSite = false;
    },
    revertSiteEdit() {
      this.$refs.editForm.reset();
    },
    submitEdit() {
      this.checkValidAddress("edit");
      if (this.$refs.editForm.validate() && this.validAddress) {
        let data = new FormData();
        data.append("name", this.editSiteName);
        data.append("project_id", this.editSiteProject);
        data.append("address", this.editSiteAddress);
        data.append("latitude", this.editLatitude);
        data.append("longitude", this.editLongitude);
        data.append("timezone", this.editTimeZone);
        data.append("assign_installer", JSON.stringify(this.editAssignInstaller));
        data.append("tariff_mode", this.editSiteTariff);
        // data.append("currency", this.editSiteCurrency);
        // if(this.editSiteImage) {
        //   data.set("image", this.editSiteImage);
        // }

        siteService
          .updateSite(this.sitesInfo.id, data)
          .then((res) => {
            if (res.status !== 200) throw res;
            const dataNewUpdate = res?.data?.data ? res.data.data : {};
            this.apiMessage = "Site's information has been successfully updated";
            this.apiTitle = "Success";
            this.messageDialog = true;
            this.siteInfo = {...this.siteInfo, ...dataNewUpdate};
            this.siteInfo.site_name = dataNewUpdate.name;
            this.getMultipleSites();
            this.closeDialogEditSite();
          })
          .catch((err) => {
            let message = "Site's information cannot be updated";
            if (err?.response?.data?.message) {
              message = err.response.data.message;
            }
            this.apiMessage = message;
            this.apiTitle = "Error";
            this.messageDialog = true;
          });
      }
    },
    handleChangeGlobalEdit(global_id) {
      this.listRegionals = [];
      this.editSiteRegional = "";
      this.listAreas = [];
      this.editSiteArea = "";
      this.listProjects = [];
      this.editSiteProject = "";
      const selectedGlobal = this.listGlobals.find(global => global.id === global_id);
      if (selectedGlobal) {
        this.listRegionals = selectedGlobal.regionals;
      }
    },
    handleChangeRegionalEdit(regional_id) {
      this.listAreas = [];
      this.editSiteArea = "";
      this.listProjects = [];
      this.editSiteProject = "";
      const selectedRegional = this.listRegionals.find(regional => regional.id === regional_id);
      if (selectedRegional) {
        this.listAreas = selectedRegional.areas;
      }
    },
    handleChangeAreaEdit(area_id) {
      this.listProjects = [];
      this.editSiteProject = "";
      const selectedArea = this.listAreas.find(area => area.id === area_id);
      if (selectedArea) {
        this.listProjects = selectedArea.projects;
      }
    },
    getAddressData(place) {
      if (place && place.geometry && place.geometry.location) {
        this.latitude = parseFloat(place.geometry.location.lat());
        this.longitude = parseFloat(place.geometry.location.lng());
        this.siteAddress = place.formatted_address;
        this.timeZone = place.utc_offset_minutes ? moment().utcOffset(place.utc_offset_minutes).format('UTCZ') : "UTC+00:00";
        this.checkValidAddress("add");
      }
    },
    getAddressDataEdit(place) {
      if (place && place.geometry && place.geometry.location) {
        this.editLatitude = parseFloat(place.geometry.location.lat());
        this.editLongitude = parseFloat(place.geometry.location.lng());
        this.editSiteAddress = place.formatted_address;
        this.editTimeZone = place.utc_offset_minutes ? moment().utcOffset(place.utc_offset_minutes).format('UTCZ') : "UTC+00:00";
        this.checkValidAddress("edit");
      }
    },
    checkValidAddress(type) {
      if(type === "edit" && (!this.editSiteAddress || !this.editLongitude || !this.editLatitude)) {
        return this.validAddress = false;
      }
      if(type === "add" && (!this.siteAddress || !this.longitude || !this.latitude)) {
        return this.validAddress = false;
      }
      return this.validAddress = true;
    },
    handleSearchSite() {
      if (this.searchSiteTimeout) {
        clearTimeout(this.searchSiteTimeout);
      }
      this.searchSiteTimeout = setTimeout(() => {
        this.dataSearch = {
          search: this.searchSite
        }
        this.getMultipleSites(this.dataSearch);
      }, 500);
    },
    openDialogFilterSite() {
      this.dialogFilterSite = true;
    },
    resetDialogFilterSite() {
      this.selectedGlobals = [];
      this.selectedRegionals = [];
      this.selectedAreas = [];
      this.selectedProjects = [];
      this.selectedInstalledDer = [];
      this.selectedSiteStatuses = [];
      this.commissionedDateRange = [];
      setTimeout(() => {
        this.resetMenuTree();
        this.$forceUpdate();
      }, 200);
    },
    closeDialogFilterSite() {
      this.dialogFilterSite = false;
    },
    openCommissionedDateMenu() {
      return this.commissionedDateMenu = !this.commissionedDateMenu;
    },
    closeCommissionedDateMenu() {
      if(this.commissionedDateRange && this.commissionedDateRange[0] && this.commissionedDateRange[1]){
        this.commissionedDateMenu = false;
      }else{
        this.commissionedDateMenu = true;
      }
      return this.commissionedDateMenu;
    },
    async submitFilter() {
      this.getSelectedMenuTreeValues();
      if(!(this.selectedGlobals?.length || this.selectedRegionals?.length || this.selectedAreas?.length || this.selectedProjects?.length || this.selectedInstalledDer?.length || this.selectedSiteStatuses?.length || this.commissionedDateRange?.length)) {
        await this.getMultipleSites();
      } else {
        let filters = {};
        if(this.selectedGlobals?.length) {
          filters.global = JSON.stringify(this.selectedGlobals);
        }
        if(this.selectedRegionals?.length) {
          filters.regional = JSON.stringify(this.selectedRegionals);
        }
        if(this.selectedAreas?.length) {
          filters.area = JSON.stringify(this.selectedAreas);
        }
        if(this.selectedProjects?.length) {
          filters.project = JSON.stringify(this.selectedProjects);
        }
        if(this.selectedInstalledDer?.length) {
          filters.installed = JSON.stringify(this.selectedInstalledDer);
        }
        if(this.selectedSiteStatuses?.length) {
          filters.status = JSON.stringify(this.selectedSiteStatuses);
        }
        if(this.commissionedDateRange?.length === 2) {
          filters.start_date = this.commissionedDateRange[0];
          filters.end_date = this.commissionedDateRange[1];
        }
        await this.getMultipleSites(this.dataSearch, filters);
      }
      this.closeDialogFilterSite();
    },
    addFields(arrayData) {
      arrayData.collapse = false;
      arrayData.isChecked = false;
      if (arrayData?.regionals?.length) {
        arrayData.regionals.forEach(regional => {
          this.addFields(regional);
          if (regional?.areas?.length) {
            regional.areas.forEach(area => {
              this.addFields(area);
              if (area?.projects?.length) {
                area.projects.forEach(project => {
                  this.addFields(project);
                });
              }
            });
          }
        });
      }
    },
    renderCollapseIcon(item) {
      item.collapse = !item.collapse;
      this.$forceUpdate();
    },
    handleCollapseChecked(item) {
      item.isChecked = true;
      this.$forceUpdate();
    },
    getSelectedMenuTreeValues() {
      this.listGlobalsFilter.forEach(globalItem => {
        if (globalItem.isChecked) {
          this.selectedGlobals.push(globalItem.name);
        }
        globalItem.regionals.forEach(regionalItem => {
          if (regionalItem.isChecked) {
            this.selectedRegionals.push(regionalItem.name);
          }
          regionalItem.areas.forEach(areaItem => {
            if (areaItem.isChecked) {
              this.selectedAreas.push(areaItem.name);
            }
            areaItem.projects.forEach(projectItem => {
              if (projectItem.isChecked) {
                this.selectedProjects.push(projectItem.name);
              }
            });
          });
        });
      });
    },
    addFieldsMenuTree() {
      this.listGlobalsFilter.forEach(country => {
        this.addFields(country);
      });
    },
    resetMenuTree() {
      this.listGlobalsFilter.forEach(globalItem => {
        globalItem.isChecked = false;
        globalItem.regionals.forEach(regionalItem => {
          regionalItem.isChecked = false;
          regionalItem.areas.forEach(areaItem => {
            areaItem.isChecked = false;
            areaItem.projects.forEach(projectItem => {
              projectItem.isChecked = false;
            });
          });
        });
      });
    },
    openDialogAddProject() {
      this.dialogAddProject = true;
    },
    closeDialogAddProject() {
      this.revertProject();
      this.dialogAddProject = false;
    },
    async submitAddProject() {
      if (this.$refs.addProjectForm.validate()) {
        const data = this.prepareDataProject(
          this.siteArea,
          this.projectName,
        );
        
        await multipleSitesService
          .storeProject(data)
          .then((res) => {
            if (res.status !== 200) throw res;
            this.getListGlobals();
            this.closeDialogAddProject();
            this.apiMessage = "Project has been successfully added";
            this.apiTitle = "Success";
            this.messageDialog = true;
          })
          .catch((err) => {
            let message = "Project cannot be added";
            if (err?.response?.data?.message) {
              message = err.response.data.message;
            }
            this.apiMessage = message;
            this.apiTitle = "Error";
            this.messageDialog = true;
          });
      }
    },
    prepareDataProject(area_id, project_name) {
      const data = {
        area_id: area_id,
        name: project_name,
      };
      return data;
    },
    revertProject() {
      this.$refs.addProjectForm.reset();
    },
    notAllowedActions () {
      return (!this.accessibleRoutes?.multi_site?.action || ['home_user', 'installer'].includes(this.user?.user_group?.type));
    },
    searchInstallers() {
      if (!this.searchTerm) {
        this.assignInstallersList = this.installersListCopy;
      } else {
        this.assignInstallersList = this.installersListCopy.filter((installer) => {
          if (installer.username && typeof installer.username === 'string') {
            return installer.username.toLowerCase().indexOf(this.searchTerm.toLowerCase()) > -1;
          } else {
            return false;
          }
        });
      }
    },
    // searchCurrency() {
    //   if (!this.searchCurrencyTerm) {
    //     this.LIST_CURRENCIES = this.currenciesListCopy;
    //   } else {
    //     this.LIST_CURRENCIES = this.currenciesListCopy.filter((currency) => {
    //       if (currency.name && typeof currency.name === 'string') {
    //         return currency.name.toLowerCase().indexOf(this.searchCurrencyTerm.toLowerCase()) > -1;
    //       } else {
    //         return false;
    //       }
    //     });
    //   }
    // },
  },
};
</script>
